export default __webpack_public_path__ + "static/pollosolopapa-7e8eeac467674426a12df0be2aa1072d.jpg";